import LayoutV2 from "containers/LayoutV2";
import SearchForm from "./SearchForm";
import PhanTrang from "components/CommonComponent/PhanTrang";
import DanhSachNhapHangTable from "./DanhSachNhapHangTable";
import React, { useEffect, useState, useCallback } from "react";
import UserApi from "service/userApi";
import { formatDayMonth } from "utils/formatDate";
import NhapHangApi from "service/QuanLyMuaBan/NhapHangApi";
import { pushNotification } from "utils/notifications";
import MenuChucNang from "./MenuChucNang";
import ThemSuaNhapHang from "./ChucNang/ThemSuaNhapHang";
import InMuaHangModal from "./ChucNang/InChiTiet";
import ModalXoaNhapHang from "./ModalXoaNhapHang";
import ModalPhiSanXuat from "./ChucNang/ModalPhiSanXuat";
const DanhSachNhapHang = () => {
    const [listUserName, setListUserName] = useState([]);
    const [hasPermission, setHasPermission] = useState(null);
    const [RoleNhapHangSua, setRoleNhapHangSua] = useState(false);
    const [RoleNhapHangXoa, setRoleNhapHangXoa] = useState(false);
    const [RoleNhapHangIn, setRoleNhapHangIn] = useState(false);
    const [RoleNhapHangThemMoi, setRoleNhapHangThemMoi] = useState(false);
    const [RoleNhapHangPhiSanXuat, setRoleNhapHangPhiSanXuat] = useState(false);
    const [ListData, setListData] = useState([]);
    const [Total, setTotal] = useState(0);
    const [TotalPrice, setTotalPrice] = useState(0);
    const [TotalAmount, setTotalAmount] = useState(0);
    const [TotalConLai, setTotalConLai] = useState(0);
    const [Loading, setLoading] = useState(true);
    //Model thêm sửa đơn nhập hàng  
    const [showModalThemSua, setShowModalThemSua] = useState(false);
    const [editingOrderId, setEditingOrderId] = useState(0);
    //Model in
    const [showModalIn, setShowModalIn] = useState(false);
    const [printOrderId, setPrintOrderId] = useState(0);
    //Model xóa
    const [showModalXoa, setShowModalXoa] = useState(false);
    const [deletingOrderId, setDeletingOrderId] = useState(0);
    //Modal phí sản xuất
    const [showModalPhiSanXuat, setShowModalPhiSanXuat] = useState(false);
    const [orderIdForPhiSX, setOrderIdForPhiSX] = useState(0);

    const fetchPermission = () => {
        setLoading(true);
        try {
            UserApi.getAllQuyen()
                .then((res) => {
                    const detailedRoles = res.data.map((item) => item.ModuleCode.toLowerCase());
                    const hasList =  detailedRoles.includes("nhaphang") || detailedRoles.includes("nhaphang_danhsach");
                    setHasPermission(hasList);
                    if (hasList) {
                        setRoleNhapHangSua(detailedRoles.includes("nhaphang_sua"));
                        setRoleNhapHangXoa(detailedRoles.includes("nhaphang_xoa"));
                        setRoleNhapHangIn(detailedRoles.includes("nhaphang_in"));
                        setRoleNhapHangThemMoi(detailedRoles.includes("nhaphang_themmoi"));
                        setRoleNhapHangPhiSanXuat(detailedRoles.includes("nhaphang_phisanxuat"));
                    }
                })
                .catch((err) => {
                    console.error("Lỗi load quyền chi tiết:", err);
                    setHasPermission(false);
                });
        } catch (err) {
            console.error("Lỗi fetchPermission:", err);
            setHasPermission(false);
        }
    };

    const loadDanhSachUserName = useCallback(() => {
        UserApi.getAllUserName()
            .then((res) => {
                setListUserName(res.data || []);
            })
            .catch((error) => {
                console.error("Lỗi load danh sách user name:", error);
            });
    }, []);

    const [dataSearch, setDataSearch] = useState({
        Type: 1, //nhập hàng = 1
        SearchText: "",
        UserName: "",
        TrangThai: 0,
        DateFrom: null,
        DateTo: null,
        pageIndex: 1,
        pageSize: 25
    });

    const LoadDanhSachNhapHang = useCallback((searchData, page) => {
        setLoading(true);
        const payload = {
            ...searchData,
            DateFrom: searchData.DateFrom
                ? formatDayMonth(searchData.DateFrom)
                : undefined,
            DateTo: searchData.DateTo
                ? formatDayMonth(searchData.DateTo)
                : undefined,
            pageIndex: page
        };

        NhapHangApi.getData(payload)
            .then((res) => {
                if (res.status === 200) {
                    const data = res.data || {};
                    setListData(data.List || []);
                    setTotal(data.TotalRecords || 0);
                    setTotalPrice(data.TotalPriceSum || 0);
                    setTotalAmount(data.TotalAmountSum || 0);
                    setTotalConLai(data.TotalConLaiSum || 0);
                    setDataSearch((prev) => ({ ...prev, pageIndex: page }));
                } else {
                    console.error("Lỗi khi load danh sách nhập hàng: ", res.message);
                    pushNotification("Load danh sách nhập hàng thất bại!", "error", "TOP_CENTER", 2000);
                }
                document.body.scrollTop = 0;
                document.documentElement.scrollTop = 0;
            })
            .catch((error) => {
                console.error("Lỗi khi gọi Api danh sách nhập hàng:", error);
                pushNotification("Có lỗi khi gọi Api danh sách nhập hàng!", "error", "TOP_CENTER", 2000);
            })
            .finally(() => {
                setLoading(false);
            });
    }, []);

    useEffect(() => {
        document.title = "Nhập hàng | Phần mềm quản lý cầm đồ Morman";
        fetchPermission();
        loadDanhSachUserName();
    }, []);

    useEffect(() => {
        if (hasPermission) {
            LoadDanhSachNhapHang(dataSearch, 1);
        }
    }, [hasPermission]);


    const onChangeData = (field) => (event) => {
        const value = event?.target?.value ?? "";
        setDataSearch((prev) => ({
            ...prev,
            [field]: value,
        }));
    };

    const onChangeDate = (field) => (value) => {
        setDataSearch((prev) => ({
            ...prev,
            [field]: value,
        }));
    };

    const handlePageChange = (pageNumber) => {
        LoadDanhSachNhapHang(dataSearch, pageNumber);
    };

    const handlePageSizeChange = (pageSize) => {
        const data = { ...dataSearch, pageSize, pageIndex: 1 };
        setDataSearch(data);
        LoadDanhSachNhapHang(data, 1);
    };

    const onSearch = () => {
        LoadDanhSachNhapHang(dataSearch, 1);
    };

    const handleKeyDown = (event) => {
        if (event.key === "Enter") {
            event.preventDefault();
            LoadDanhSachNhapHang(dataSearch, 1);
        }
    };

    const btnThemDonNhapHangClick = () => {
        setEditingOrderId(0);
        setShowModalThemSua(true);
    };

    const btnSuaDonNhapHangClick = (orderId) => {
        setEditingOrderId(orderId);
        setShowModalThemSua(true);
    };

    const btnXoaDonNhapHangClick = (orderId) => {
        setDeletingOrderId(orderId);
        setShowModalXoa(true);
    };

    const btnInNhapHangClick = (orderId) => {
        setPrintOrderId(orderId);
        setShowModalIn(true);
    };

    const onCloseThemSuaModal = (isSuccess) => {
        setShowModalThemSua(false);
        setEditingOrderId(0);
        if (isSuccess === true) {
            onSearch();
        }
    };

    const onCloseInModal = () => {
        setShowModalIn(false);
        setPrintOrderId(0);
    };

    const onCloseXoaModal = (isSuccess) => {
        setShowModalXoa(false);
        setDeletingOrderId(0);
        if (isSuccess === true) {
            onSearch();
        }
    };

    const btnPhiSanXuatClick = (orderId) => {
        setOrderIdForPhiSX(orderId);
        setShowModalPhiSanXuat(true);
    };
    const onClosePhiSanXuatModal = (isSuccess) => {
        setShowModalPhiSanXuat(false);
        setOrderIdForPhiSX(0);
        if (isSuccess === true) {
            onSearch();
        }
    };

    if (hasPermission === false) {
        return (
            <LayoutV2>
                <h2 className="text-danger">
                    <div className="custom-table-row">
                        <div
                            className="custom-table-cell text-center red"
                            style={{ width: "100%" }}
                        >
                            Bạn không có quyền truy cập trang này!
                        </div>
                    </div>
                </h2>
            </LayoutV2>
        );
    }
    return (
        <>
            <LayoutV2>
                <div id="form-repeater">
                    <div className="sticky-moman-bh">
                        <div className="col-12">
                            <div className="camdo-home">
                                <div className="breadcrumb-new">
                                    <div className="row">
                                        <div className="col-sm-12 col-md-12 title-cd">
                                            <div className="media-home align-center-home">
                                                <div className="row header">
                                                    <img
                                                        src="/app-assets/images/logo-quan-ly-mua-ban-nhap-hang-v2.png"
                                                        alt="logo"
                                                    />
                                                    <h1 className="text-info-home">Quản lý mua bán - Nhập hàng</h1>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    className="card border-light mb-1 show-table-main card-v2"
                                    style={{}}
                                >
                                    <div className="card-body card-body-v2">
                                        <SearchForm
                                            listUserName={listUserName}
                                            dataSearch={dataSearch}
                                            onChangeData={onChangeData}
                                            onChangeDate={onChangeDate}
                                            onSearch={onSearch}
                                            handleKeyDown={handleKeyDown}
                                        />
                                    </div>
                                </div>
                                {Loading && (<>
                                    <div className="loader loader-default is-active"></div>
                                </>)}
                                {!Loading && (<>
                                    <div
                                        className="card border-light mb-1 card-v2"
                                        style={{ marginTop: "0px" }}
                                    >
                                        <div className="card-body card-body-v2" style={{ userSelect: "text" }}>
                                            <MenuChucNang
                                                dataSearch={dataSearch}
                                                listUserName={listUserName}
                                                btnThemMoiClick={btnThemDonNhapHangClick}
                                                RoleThemMoi={RoleNhapHangThemMoi}
                                                RoleIn={RoleNhapHangIn}
                                            />
                                            <DanhSachNhapHangTable
                                                listUserName={listUserName}
                                                list={ListData}
                                                Total={Total}
                                                TotalPrice={TotalPrice}
                                                TotalAmount={TotalAmount}
                                                TotalConLai={TotalConLai}
                                                btnSuaNhapHangClick={btnSuaDonNhapHangClick}
                                                btnXoaNhapHangClick={btnXoaDonNhapHangClick}
                                                btnInNhapHangClick={btnInNhapHangClick}
                                                btnPhiSanXuatClick={btnPhiSanXuatClick}
                                                RoleSua={RoleNhapHangSua}
                                                RoleXoa={RoleNhapHangXoa}
                                                RoleIn={RoleNhapHangIn}
                                                RolePhiSanXuat={RoleNhapHangPhiSanXuat}
                                            />
                                        </div>
                                        <div
                                            className="card border-light mb-1 card-v2"
                                            style={{
                                                marginLeft: "15px",
                                                marginRight: "15px",
                                                marginTop: "15px",
                                            }}
                                        >
                                            <div
                                                className="card-body card-body-v2"
                                                style={{ display: Total === 0 ? "none" : "block" }}
                                            >
                                                <PhanTrang
                                                    pageIndex={dataSearch.pageIndex}
                                                    pageSize={dataSearch.pageSize}
                                                    totalCount={Total}
                                                    onPageChange={handlePageChange}
                                                    onPageSizeChange={handlePageSizeChange}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </>)}
                            </div>
                        </div>
                    </div>
                </div>
            </LayoutV2>
            {showModalThemSua && (
                <ThemSuaNhapHang
                    orderId={editingOrderId}
                    onClose={onCloseThemSuaModal}
                />
            )}
            {showModalIn && (<>
                <div
                    style={{
                        backgroundColor: "rgba(0,0,0,0.4)",
                        top: 0,
                        left: 0,
                        width: "100vw",
                        height: "100vh",
                        zIndex: 2500,
                    }}
                ></div>
                <div style={{ zIndex: 9000, position: "relative" }}>
                    <InMuaHangModal
                        show={showModalIn}
                        onHide={onCloseInModal}
                        orderId={printOrderId}
                    />
                </div>
            </>)}
            {showModalXoa && (
                <ModalXoaNhapHang
                    orderId={deletingOrderId}
                    show={showModalXoa}
                    onHide={() => onCloseXoaModal(false)}
                    onSaved={() => onCloseXoaModal(true)}
                />
            )}
            {showModalPhiSanXuat && (
                <ModalPhiSanXuat
                    orderId={orderIdForPhiSX}
                    onClose={onClosePhiSanXuatModal}
                />
            )}
        </>
    )

}
export default DanhSachNhapHang;